import { render } from "./InputPeriodVolume.vue?vue&type=template&id=5cd411b2"
import script from "./InputPeriodVolume.vue?vue&type=script&lang=js"
export * from "./InputPeriodVolume.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__